module.exports = __webpack_public_path__ + "img/EDQ04_Z.b855476b.png";